// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type CreateReimbursementParams = {
  amount: string,
  member_description: string,
  type: 'HSA' | 'ICHRA',
  purpose?: string,
  receipts?: File[],
  transaction_date?: string,
}

export type ReimbursementCreated = {
  reimbursement_id: string,
  reimbursement_state: string,
  redirect_to: string,
  status_message?: string,
}

export function useCreateReimbursement () {
  return useMutation<ReimbursementCreated, GrapeAPIErrorType, CreateReimbursementParams | FormData>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'post',
        '/api/web/reimbursements',
        {
          body: params,
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
